import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {layoutTemplateSchema} from '../utils/schemas/layout';

import {layoutTemplateKeys} from './queryKeys';

import type {
  QueryConfig,
  ExtractFnReturnType,
  QueryConfig2,
} from '@/lib/react-query';

export const getLayoutTemplate = async (id: string) => {
  const data = await api.get(`layouts/${id}`).json();
  return layoutTemplateSchema.parse(data);
};

export const useLayoutTemplate = (
  id: string,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: layoutTemplateKeys.detail(id),
    queryFn: () => getLayoutTemplate(id),
  });
};
export const useLayoutTemplateLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getLayoutTemplate;
